@if (
  {
    signInJourney: authenticationState.signInJourney$ | async,
    mfaOptions: authenticationState.signInMfaOptions$ | async,
    newPasswordOptions: authenticationState.completePasswordOptions$ | async
  };
  as signInOptions
) {
  @if (message && message.title) {
    <mat-card class="mb-5" id="message-container" tid="message-container">
      <app-content style="margin: 1.2rem">
        <app-body-md ink="ink-white" bold>{{ message.title }}</app-body-md>
      </app-content>
      @if (message.body) {
        <app-p>{{ message.body }}</app-p>
      }
    </mat-card>
  }
  <ng-template #loginHelp>
    <div class="login-header">
      <div class="login-text">Login</div>
      <app-button
        (click)="goToHelp()"
        [iconLeft]="true"
        iconColor="primary-action"
        iconHoverColor="primary-action"
        buttonText="Help"
        class="help-button"
        theme="ink-02"
        [uppercaseText]="false"
        [iconConfig]="{
          usePhosphorIcon: true,
          iconName: 'question',
          outlined: true,
          hoverColor: 'white',
          size: 'small'
        }"
        bypassLoadingRequirement
      ></app-button>
    </div>
  </ng-template>
  @if (!(signInOptions.signInJourney || signInOptions.newPasswordOptions)) {
    <ng-container [formGroup]="signInFormGroup">
      <div class="welcome-text">Welcome</div>
      <div>
        <ng-template [ngTemplateOutlet]="loginHelp"></ng-template>
      </div>
      <form (ngSubmit)="signIn()">
        <app-input
          id="login-email"
          tid="username"
          type="email"
          [emailField]="true"
          formPropertyName="username"
          placeholder="Login Email"
          appAutoFocus
        ></app-input>
        <div class="continue-button-container">
          <app-button
            tabindex="0"
            theme="primary-v2"
            type="submit"
            [loading]="fetching$ | async"
            tid="submit-button"
            buttonText="Continue"
            [buttonWidth]="'full'"
            [uppercaseText]="false"
            [iconLeft]="true"
            [iconColor]="'white'"
            [fontColor]="'white'"
            [iconConfig]="{
              usePhosphorIcon: true,
              iconName: 'arrow-circle-right',
              outlined: false,
              hoverColor: 'white',
              size: 'small'
            }"
            bypassLoadingRequirement
          ></app-button>
        </div>
      </form>
    </ng-container>
  }
  @if (signInOptions.signInJourney === 'UserPasswordMfa' && !signInOptions.mfaOptions) {
    <ng-container [formGroup]="passwordSignInGroup">
      <ng-template [ngTemplateOutlet]="loginHelp"></ng-template>
      <form (ngSubmit)="signInPassword()">
        <app-input
          tid="username"
          type="email"
          [emailField]="true"
          formPropertyName="username"
          label="Email"
          [readonlyField]="true"
        ></app-input>
        <app-password-input
          label="Password"
          tId="password"
          formPropertyName="password"
          placeholder="Enter your password"
          style="margin-top: 2.4rem; display: block"
          appAutoFocus
        ></app-password-input>
        <app-button
          theme="secondary-action"
          class="forgot-password-button"
          (click)="requestResetPassword()"
          basicButton="true"
          tid="forgot-password-button"
          bypassLoadingRequirement
          >Forgot your password</app-button
        >
        <div class="footer-actions">
          <div id="cancel-container">
            <app-button
              theme="secondary-action"
              (click)="cancel()"
              [buttonWidth]="'full'"
              bypassLoadingRequirement
              [fontColor]="'primary-v2'"
              >Back</app-button
            >
          </div>
          <div class="action-container">
            <app-button
              theme="primary-v2"
              type="submit"
              [loading]="fetching$ | async"
              tid="submit-button"
              [buttonWidth]="'full'"
              [uppercaseText]="false"
              [fontColor]="'white'"
              >Login
            </app-button>
          </div>
        </div>
      </form>
    </ng-container>
  }
  @if (signInOptions.mfaOptions && signInOptions.mfaOptions.mfaType === 'CustomSMS') {
    <ng-container [formGroup]="mfaFormGroup">
      <form (ngSubmit)="signInMfa()">
        <app-h4 noMargin>Secure Code</app-h4>
        <p>Enter the code that we sent to {{ getMaskedPhoneNumber($any(signInOptions.mfaOptions).challengeMobileNumber) }}</p>
        <app-input
          tid="sms"
          type="text"
          formPropertyName="mfaCode"
          label="Security code"
          placeholder="Security code"
          appAutoFocus
          title="Security code"
          [maxLength]="6"
        ></app-input>

        <app-lost-phone-banner></app-lost-phone-banner>

        <div class="footer-actions">
          <div id="cancel-container">
            <app-button theme="primary-action" (click)="cancel()" basicButton="true" bypassLoadingRequirement>Back</app-button>
          </div>
          <div class="action-container">
            <app-button theme="primary-action" type="submit" [loading]="fetching$ | async" tid="submit-button">Login</app-button>
          </div>
        </div>
      </form>
    </ng-container>
  }

  @if (signInOptions.mfaOptions && (signInOptions.mfaOptions.mfaType === 'TOTP' || signInOptions.mfaOptions.mfaType === 'TOTP_Restart')) {
    <ng-container [formGroup]="mfaFormGroup">
      <form (ngSubmit)="signInMfa()">
        <app-h4 noMargin>Secure Code</app-h4>
        <p>Enter the 6-digit code from your authenticator app to continue.</p>

        <app-input
          tid="totp"
          type="text"
          formPropertyName="mfaCode"
          label="Security code"
          placeholder="Security code"
          appAutoFocus
          title="Security code"
          [maxLength]="6"
        ></app-input>

        <app-lost-phone-banner></app-lost-phone-banner>

        <div class="footer-actions">
          <div id="cancel-container">
            <app-button theme="primary-action" (click)="cancel()" basicButton="true" bypassLoadingRequirement>Back</app-button>
          </div>
          <div class="action-container">
            <app-button theme="primary-action" type="submit" [loading]="fetching$ | async" tid="submit-button">Login</app-button>
          </div>
        </div>
      </form>
    </ng-container>
  }

  @if (signInOptions.newPasswordOptions) {
    <ng-container [formGroup]="confirmPasswordFormGroup">
      <form (ngSubmit)="completeNewPassword()">
        <app-password-reset-controls #passwordResetControls></app-password-reset-controls>
        <div class="footer-actions">
          <div id="cancel-container">
            <app-button theme="primary-action" (click)="cancel()" basicButton="true" bypassLoadingRequirement>Back</app-button>
          </div>
          <div class="action-container">
            <app-button theme="primary-action" type="submit" [loading]="fetching$ | async" tid="submit-button">Create Password</app-button>
          </div>
        </div>
      </form>
    </ng-container>
  }
}
